import { navItemsData } from "../../../lib/config";
import { useAppSettings } from "../../../contexts/AppSettingsContext";
import { Link } from "react-router-dom";
import NavItem from "./NavItem"
import NavUser from "./NavUser"
import { useAuth } from '../../../contexts/AuthContext';

const SideMenu = () => {
    const { applicationSettings } = useAppSettings();
    const { drawingPackage } = useAuth();

    return (
        <nav className="pc-sidebar hive-base-side-menu">

            <div className="navbar-wrapper">

                <div className="m-header">
                    <Link to="/dashboard" className="b-brand text-primary">
                        <img src="/images/LOGO.png" alt="logo" style={{width: "60px", margin: "0.75em"}} />
                        <span className="badge bg-light-success rounded-pill ms-2 theme-version">{applicationSettings.applicationVersion}</span>
                    </Link>
                </div>

                <div className="navbar-content">

                    <NavUser />

                    <ul className="pc-navbar hive-base-side-menu-list">
                        {navItemsData.map((item, index) => (
                            <NavItem key={index} {...item} {...(item.link === '/3d-drawings' && drawingPackage !== true ? { disabled: true, disabledTooltip: 'To enable this feature, contact your system admin.' } : {})} />
                        ))}
                    </ul>

                </div>

            </div>
        </nav>
    )
}

export default SideMenu
